import { render, staticRenderFns } from "./DisclaimerForMinorPatient.vue?vue&type=template&id=1cfd20d8&scoped=true"
import script from "./DisclaimerForMinorPatient.vue?vue&type=script&lang=js"
export * from "./DisclaimerForMinorPatient.vue?vue&type=script&lang=js"
import style0 from "./DisclaimerForMinorPatient.vue?vue&type=style&index=0&id=1cfd20d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfd20d8",
  null
  
)

export default component.exports